import fetch from '@/utils/fetch';

export function login(param) {
    return fetch({
        // url: '/User/User/login',
        url: '/auth/login',
        method: 'post',
        data: param
    });
}

export function getUserRuleList(param) {
    return fetch({
        // url: '/Rule/Rule/getUserRuleList',
        url: '/eavar/user/getUserRuleList',
        method: 'post',
        params: param
    });
}

export function logout() {
    return fetch({
        url: '/User/User/logout',
        method: 'post'
    });
}

export function passCodeSet(param) {
    return fetch({
        // url: '/User/User/modifyPassword',
        url: '/eavar/modifyPassword',
        method: 'post',
        data: param
    });
}

export function userSSet(param) {
    return fetch({
        url: '/User/User/updateUserChangePasswordStatus',
        method: 'post',
        data: param
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js